import { createSlice } from '@reduxjs/toolkit';
import * as Seters from './seters';

export interface State {
	modalOpen: boolean;
}

export const initialState: State = {
	modalOpen: false,
};

export const slice = createSlice({
	name: 'ui/mobileSummaryModal',
	initialState,
	reducers: Seters,
});

export const mobileSummaryModalReducer = slice.reducer;
const Actions = slice.actions;
export { Actions };
